import "./LabDirectorDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";

interface LabDirectorDetailsViewComponentProps {
    directorDetails: any;
    onEditModeOpen?: Function;
    canEdit?: boolean;
}

const LabDirectorDetailsViewComponent = (props: LabDirectorDetailsViewComponentProps) => {
    const {directorDetails, onEditModeOpen, canEdit} = props;

    return (
        <div className="lab-director-details-component details-tab-data-content">
            <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Personal Details</div>
                    {canEdit &&
                        <div className="">
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"NPI Number"}> {directorDetails?.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Middle Name"}> {directorDetails?.middleName || 'N/A'} </DetailsDataKeyValueComponent>
                            {/*<DetailsDataKeyValueComponent*/}
                            {/*    title={"Gender"}> {directorDetails?.gender || 'N/A'} </DetailsDataKeyValueComponent>*/}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"First Name"}> {directorDetails?.firstName || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Last Name"}> {directorDetails?.lastName || 'N/A'} </DetailsDataKeyValueComponent>
                            {/*<DetailsDataKeyValueComponent*/}
                            {/*    title={"Date of Birth"}> {directorDetails?.dateOfBirth ? commonService.formatDate(directorDetails?.dateOfBirth) : 'N/A'} </DetailsDataKeyValueComponent>*/}
                        </Grid>
                    </Grid>
                </div>
                <div className="horizontal-line"/>
                <div className="view-and-edit-title">Contact Details</div>
                <div className="details-tab-data-body">

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {directorDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Secondary Mobile Number"}> {CommonService.getMaskedMobileNumber(directorDetails?.secondaryMobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(directorDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Fax Number"}> {CommonService.getMaskedMobileNumber(directorDetails?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
                <div className="horizontal-line"/>
                <div className="view-and-edit-title">Director Attachment</div>
                <div className="details-tab-data-body">
                    <div className="attachment-list-wrapper">
                        {(directorDetails?.attachments || [])?.map((attachment: any) =>
                            <div key={CommonService.getUUID()}>
                                <AttachmentViewDownloadComponent
                                    attachmentTitle={attachment.attachmentName}
                                    attachment={attachment}
                                />
                            </div>
                        )}
                    </div>
                    {
                        (directorDetails?.attachments || []).length === 0 &&
                        <FeedbackComponent className={"mrg-top-25"}>
                            No attachments found
                        </FeedbackComponent>
                    }
                </div>
            </>
            {/* <div className=" no-data-card-with-gif animated-gif-wrapper">*/}
            {/* <img src={ImageConfig.NoDataGif} alt={"no data found"}/>*/}
            {/* <div className="table-no-data-found">No data to show</div>*/}
            {/* </div>*/}
            {/*}*/}
        </div>

    );

};

export default LabDirectorDetailsViewComponent;
